// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".WHuQRJNkbS8SP8WVsREm {\n  margin-top: 120px;\n}\n", "",{"version":3,"sources":["webpack://./src/views/Album/CreateAlbum/CreateAlbum.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB","sourcesContent":[".createAlbumView {\n  margin-top: 120px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"createAlbumView": "WHuQRJNkbS8SP8WVsREm"
};
export default ___CSS_LOADER_EXPORT___;
